"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToolTipProvider_1 = require("../tooltips/ToolTipProvider");
var mouseClickHandler_1 = require("../mouseClickHandler");
exports.nonSelectableGridClass = zebra.Class(zebra.ui.grid.Grid, [
    function (hoverFont) {
        this.isPresetRow = true;
        if (hoverFont) {
            this.toolTipHandler = new ToolTipProvider_1.ToolTipProvider(hoverFont);
            this.toolTipHandler.setGrid(this);
        }
        this.$super();
    },
    function addClickHandling(condition, action) {
        this.clickCondition = condition;
        this.clickAction = action;
    },
    function mouseClicked(e) {
        mouseClickHandler_1.MouseClickHandler.registerEvent(this, e, this.clickCondition, this.clickAction);
        this.$super(e);
    },
    function select(row, b) {
        return;
    }
]);
//# sourceMappingURL=NonSelectableGrid.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/NonSelectableGrid.js
// module id = 80
// module chunks = 0